/**
 * 此处存放样式相关所有逻辑
 */

export default {
  props: {},

  watch: {
    dangerColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-danger-color', val);
        }
      },
    },

    primaryColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-primary-color', val);
        }
      },
    },

    borderColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-border-color', val);
        }
      },
    },

    borderRaduis: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-border-radius', val ? `${val}px` : '');
        }
      },
    },

    bgColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-bg-color', val);
        }
      },
    },

    placeholderColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-placeholder-color', val);
        }
      },
    },

    multiTagColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-multitag-color', val);
        }
      },
    },

    multiTagFontSize: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-multitag-font-size', val);
        }
      },
    },

    multiTagFontWeight: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-multitag-font-weight', val);
        }
      },
    },

    descColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-desc-color', val);
        }
      },
    },

    descFontSize: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-desc-font-size', val);
        }
      },
    },

    descFontWeight: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-desc-font-weight', val);
        }
      },
    },

    titleColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-title-color', val);
        }
      },
    },

    titleFontSize: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-title-font-size', val);
        }
      },
    },

    titleFontWeight: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-title-font-weight', val);
        }
      },
    },

    textColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-text-color', val);
        }
      },
    },

    textFontSize: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-text-font-size', val);
        }
      },
    },

    textFontWeight: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-text-font-weight', val);
        }
      },
    },

    submitBg: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-submit-bg', val ? `url(${val})` : '');
        }
      },
    },

    submitColor: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-submit-color', val);
        }
      },
    },

    submitFontSize: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-submit-font-size', val);
        }
      },
    },

    submitFontWeight: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.setStyle('--customize-form-submit-font-weight', val);
        }
      },
    },
  },

  methods: {
    setStyle(name, value) {
      this.$nextTick(() => {
        this.$refs.containerRef && this.$refs.containerRef.style.setProperty(name, value);
      });
    },
  },
};